/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Progress_Report_Span_WeekInputs */

const en_us2_progress_report_span_week = /** @type {(inputs: Progress_Report_Span_WeekInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Week`)
};

const pt_br2_progress_report_span_week = /** @type {(inputs: Progress_Report_Span_WeekInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Semana`)
};

const es_419_progress_report_span_week = /** @type {(inputs: Progress_Report_Span_WeekInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Semana`)
};

const pt_pt2_progress_report_span_week = /** @type {(inputs: Progress_Report_Span_WeekInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Semana`)
};

const fr_fr2_progress_report_span_week = /** @type {(inputs: Progress_Report_Span_WeekInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Semaine`)
};

const de_de2_progress_report_span_week = /** @type {(inputs: Progress_Report_Span_WeekInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Woche`)
};

const it_it2_progress_report_span_week = /** @type {(inputs: Progress_Report_Span_WeekInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Settimana`)
};

/**
* | output |
* | --- |
* | "Week" |
*
* @param {Progress_Report_Span_WeekInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const progress_report_span_week = /** @type {((inputs?: Progress_Report_Span_WeekInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Progress_Report_Span_WeekInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_progress_report_span_week(inputs)
	if (locale === "es-419") return es_419_progress_report_span_week(inputs)
	if (locale === "pt-PT") return pt_pt2_progress_report_span_week(inputs)
	if (locale === "fr-FR") return fr_fr2_progress_report_span_week(inputs)
	if (locale === "de-DE") return de_de2_progress_report_span_week(inputs)
	if (locale === "it-IT") return it_it2_progress_report_span_week(inputs)
	return en_us2_progress_report_span_week(inputs)
});
export { progress_report_span_week as "progress-report.span_week" }